/**
 * Loading Spinner Component
 *
 * Displays a spinning loader with configurable size.
 */

import type { ReactElement } from "react";

interface LoadingSpinnerProps {
  readonly size?: "sm" | "md" | "lg";
  readonly className?: string;
}

const sizeClasses = {
  sm: "h-4 w-4 border-2",
  md: "h-8 w-8 border-2",
  lg: "h-12 w-12 border-3",
} as const;

export function LoadingSpinner({ size = "md", className = "" }: LoadingSpinnerProps): ReactElement {
  return (
    <div
      className={`animate-spin rounded-full border-primary border-t-transparent ${sizeClasses[size]} ${className}`}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}
